import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type TodoStepItem = {
  id: string;
  title: string;
  isCompleted: boolean | null;
  position: number | null;
  createdAt: Date | null;
};

export type TodoItemWithSteps = {
  id: string;
  title: string;
  description: string | null;
  isCompleted: boolean | null;
  dueDate: Date | null;
  position: number | null;
  createdAt: Date | null;
  updatedAt: Date | null;
  sessionId: string;
  steps: TodoStepItem[];
  generationStatus: string | null; // 'pending' | 'processing' | 'completed' | 'failed'
  generationResult: string | null;
  suggestions: string | null; // JSON array of suggestions
  generationProgressMessage?: string | null; // Optional progress message during AI generation
  generationProgressPercent?: number | null; // Optional numeric progress (0-100)
  ambiguous?: boolean | null; // Whether this todo allows AI judgement
};

export type OutputType = {
  todos: TodoItemWithSteps[];
};

export const getTodosList = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/todos/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
